//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Facturas from '@/api/promotores/facturas.api'
export default {
  data() {
    return {
      per_page_options: [10, 20, 30, 40, 50, 100],
      facturas: [],
      columns: [
        {
          name: "proveedor_nombre",
          field: "proveedor_nombre",
          label: "Proveedor",
          sortable: true,
          align: "left",
          classes: "bg-grey-2 ellipsis",
          headerClasses: "bg-primary text-white",
        },
        {
          name: "rfc_emisor",
          field: "rfc_emisor",
          label: "RFC Emisor",
        },
        { name: "rfc_receptor", field: "rfc_receptor", label: "RFC Receptor" },
        { name: "subtotal", field: "subtotal", label: "Subtotal", format: this.currency },
        { name: "total", field: "total", label: "Total", format: this.currency },
        { name: "estatus", field: "estatus", label: "Estatus", format: this.getStatus },
        { name: "uuid", field: "uuid", label: "UUID" , format: this.mostrarUUID},
        { name: "created_at", field: "created_at", label: "Fecha" },
      ],
      loading: false,
    }
  },

  mounted() {
    this.loadFacturas()
  },

  methods: {
    async loadFacturas() {
      try {
        this.loading = true
        const response = await Facturas.all()
        this.facturas = response.reverse()
      } finally {
        this.loading = false
      }
    },
    getStatus(status) {
      return {
        0: "Rechazada",
        1: "Sin revisar",
        2: "Aceptada sin revisión",
        3: "En revisión por director de Finanzas",
        4: "En revisión por director de Finanzas y General",
        5: "En proceso de pago",
        6: "Pagada",
      }[status]
    },
    mostrarUUID(uuid) {
      return `${uuid.substring(0, 17)}...`;
    }
  },
}
